import { isNullOrUndefined } from '../helpers/helpers';

/**
 * Link type on the bucket template.
 */
const getBucketLinkType = (bucketTemplate, type) => {
  if (!bucketTemplate) return null;

  const streamType = type === 'customer' ? 'upstreamTypes' : 'downstreamTypes';
  const types = [
    ...(bucketTemplate[streamType] || []),
  ].filter((t) => typeof t === 'string' && t.includes(type));

  if (types.length === 0) return null;

  const one = `${type}-one`;
  const many = `${type}-many`;

  if (types.includes(one)) return one;
  if (types.includes(many)) return many;

  return null;
};

/**
 * Links an existing customer from customerMap to the bucket payload (customer-one / customer-many: [id]).
 * @param {Object} row - Row data from spreadsheet
 * @param {Object} context - Context with selectedBucketTemplate and customerMap
 * @param {Object} payload - Payload to apply customer link to
 * @returns {string} Error message, or empty string on success
 */
export const applyBucketImportCustomerLink = (row, context, payload) => {
  const name = isNullOrUndefined(row.customer) ? '' : String(row.customer).trim();
  if (!name) return '';

  const linkType = getBucketLinkType(context.selectedBucketTemplate, 'customer');
  if (!linkType) {
    return 'This bucket template has no customer link. Remove the Customer column or choose a template that links to customers.';
  }

  const customerId = context.customerMap?.[name]?.id;
  if (!customerId) {
    return `Customer "${name}" not found. Use the exact customer name or import customers first.`;
  }

  payload[linkType] = [customerId];

  return '';
};

/**
 * Links an existing project from projectMap to the bucket payload (project-one / project-many: [id]).
 * @param {Object} row - Row data from spreadsheet
 * @param {Object} context - Context with selectedBucketTemplate and projectMap
 * @param {Object} payload - Payload to apply project link to
 * @returns {string} Error message, or empty string on success
 */
export const applyBucketImportProjectLink = (row, context, payload) => {
  const name = isNullOrUndefined(row.project) ? '' : String(row.project).trim();
  if (!name) return '';

  const linkType = getBucketLinkType(context.selectedBucketTemplate, 'project');
  if (!linkType) {
    return 'This bucket template has no project link. Remove the Project column or choose a template that links to projects.';
  }

  const projectId = context.projectMap?.[name]?.id;
  if (!projectId) {
    return `Project "${name}" not found. Use the exact project name or import projects first.`;
  }

  payload[linkType] = [projectId];

  return '';
};
